import { render, staticRenderFns } from "./CalorieCalculator.vue?vue&type=template&id=a5fa1016&scoped=true"
import script from "./CalorieCalculator.vue?vue&type=script&lang=js"
export * from "./CalorieCalculator.vue?vue&type=script&lang=js"
import style0 from "./CalorieCalculator.vue?vue&type=style&index=0&id=a5fa1016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fa1016",
  null
  
)

export default component.exports